<template>
    <div class="app-main goods-list">

        
        <div class="top-bar">
            <el-input placeholder="输入商品名称搜索" v-model="searchVal" @change="search('zh')" style="width:210px;margin-right:20px;">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
        </div>
        <!-- 商品列表 -->
        <el-card shadow="hover">
            <el-table ref="multipleTable" :data="tableData"  height="600" style="width: 100%">
                <el-table-column label="商品图片" fixed align="center" width="100">
                    <template slot-scope="scope">
                        <m-img v-if="scope.row.url" :src="scope.row.url" />
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="商品名称"  align="center"  width="200" show-overflow-tooltip></el-table-column>
                <el-table-column prop="name"  label="商品类型" align="center" width="140">
                    <template slot-scope="scope">
                        <span v-if="scope.row.goods_type == 2">食品类型</span>
                        <span v-else-if="scope.row.goods_type == 3">服务类型</span>
                        <span v-else>普通商品</span>
                    </template>
                </el-table-column>
                <el-table-column prop="is_zh" label="中文录入"  align="center"  width="140" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-link type="success" v-if="scope.row.is_zh == 1">是</el-link>
                        <el-link type="danger"  v-if="scope.row.is_zh == 2">否</el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="is_en" label="英文录入"  align="center"  width="140" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-link type="success" v-if="scope.row.is_en == 1">是</el-link>
                        <el-link type="danger"  v-if="scope.row.is_en == 2">否</el-link>
                    </template>
                </el-table-column>
                <el-table-column v-if="false" prop="status" align="center" label="商品状态" width="160">
                    <template slot-scope="scope">
                        <el-link type="success" v-if="scope.row.status == 1">已上架</el-link>
                        <el-link type="danger"  v-if="scope.row.status == 2">已下架</el-link>
                        <el-link type="info"    v-if="scope.row.status == 3">待审核</el-link>
                        <el-link type="success" v-if="scope.row.status == 4">待上架</el-link>
                        <el-link type="danger"  v-if="scope.row.status == 5">已回收</el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="updated_at"  align="center" label="录入时间" width="180"></el-table-column>
                <el-table-column v-if="false" prop="visits"   align="center" label="游览量" width="180"></el-table-column>
                <el-table-column v-if="false"  prop="sales_volume" align="center" label="商品销量" width="150" sortable>
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.sales_volume" @change="handleSales(scope.row)" size="mini" style="width:80px" readonly></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="totalMoney"  align="center" label="商品操作" width="200">
                    <template slot-scope="scope">
                        <div class="table-btns">
                            <el-button v-if="scope.row.status == 1" @click="goodsEdit(scope.row, 2)" type="danger" plain size="mini">下架商品</el-button>
                            <el-button v-if="scope.row.status == 2 || scope.row.status == 4" @click="goodsEdit(scope.row, 1)" type="success" plain size="mini" style="margin:5px 0 0 0">上架商品</el-button>
                            <el-button v-if="scope.row.status == 2" @click="goodsEdit(scope.row, 5)" type="danger" plain size="mini" style="margin:5px 0 0 0">删除商品</el-button>
                            <el-button v-if="scope.row.status != 1" @click="$router.push({path: `/goods/presale/edit/${scope.row.id}`,query: {param: scope.row.is_zh == 1 ? 'en':'zh'}})" type="primary" plain size="mini" style="margin:5px 0 0 0">修改商品</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background @current-change="reloadData" :current-page.sync="page" layout="prev, pager, next, jumper" style="padding:15px" :total="total" :page-size="20" ></el-pagination>
        </el-card>



        <el-dialog title="批量修改商品是否为食物" center :visible.sync="food_modal" width="600px">
            <span class="first-class" style="margin-right:30px;">是否为食物</span>
            <el-radio v-model="is_food" label="1">是</el-radio>
            <el-radio v-model="is_food" label="0">否</el-radio>
            <div style="margin:30px 0 20px;display:flex;algin-items:center;justify-content:center;">
                <el-button type="success"  style="width:120px;margin-left:30px;" @click="handleFood" :loading="food_load">确定修改</el-button>
            </div>
            
        </el-dialog>


        <el-dialog :title="sku_title" :visible.sync="sku_modal">
            <el-card shadow="hover">
                <el-table :data="sku" max-height="400px">
                    <el-table-column property="attr_symbol_string" label="规格属性" width="120" align="center"></el-table-column>
                    <el-table-column property="barcode" label="SKU" width="160" align="center"></el-table-column>
                    <el-table-column property="price"   label="进货价">
                        <template slot-scope="scope">C${{scope.row.price}}</template>
                    </el-table-column>
                    <el-table-column property="address" label="长" align="center">
                        <template slot-scope="scope">
                            <el-input  v-model="scope.row.number" size="mini" style="width:80px"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column property="address" label="宽" align="center">
                        <template slot-scope="scope">
                            <el-input  v-model="scope.row.number" size="mini" style="width:80px"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column property="address" label="高" align="center">
                        <template slot-scope="scope">
                            <el-input  v-model="scope.row.number" size="mini" style="width:80px"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column property="address" label="重量" align="center">
                        <template slot-scope="scope">
                            <el-input  v-model="scope.row.number" size="mini" style="width:80px"></el-input>
                        </template>
                    </el-table-column>
                </el-table>
            </el-card>
        </el-dialog>


    </div>
</template>



<script>
/* eslint-disable */
import { presell_goodsList, goods_status } from '@/api/goods.js'

import MImg   from './../../../components/Image'

export default {
    components: { MImg },
    data() {
        return {
            selectVal:'',
            searchVal: '',
            searchEnVal:'',
            tableData:[],
            table_load:false,
            checkData:[],
            total:0,
            page:1,
            goods_modal:false,
            sku:[],
            goodsId:'',                   //商品ID


            sku_title: '',
            sku_modal: false,
        }
    },
    methods: {
        search() {
            this.page = 1
            this.getData()
        },
        getData(){
            this.tableData = [];
            let params = {
                page:this.page,
            }
            if(this.searchVal != ""){
                params.search = this.searchVal;
            }
            presell_goodsList(params).then(res => {
                if(res){
                    this.tableData = res.data.data
                    this.total = res.data.total
                }else{
                    this.tableData = [];
                }
            })
        },
        reloadData(page){
            this.page = page;
            this.getData();
            this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
        },
        goodsEdit(row,flag){
            let params = {
                status:flag
            }
            goods_status(row.id,params).then(res => {
                if(res){
                    this.$message({message:res.msg,type:'success'})
                    this.getData()
                }else{
                    this.$message.error(res.msg)
                }
            }).catch(err => {
                this.table_load = false;
                console.log(err)
            })
        },
        // 监听选中 table 事件 
        handleSelectionChange(rows){
            this.checkData = rows
        },
        handleSales(row){
            let params = {
                sales_volume:row.sales_volume,
            }
            goodsSelf_edit(row.goods_id,params).then(res => {
                if(res.status == 1){
                    this.$message({message:'修改销量成功',type:'success'})
                }else{
                    this.$message.error({msg:res.msg});
                    this.getData()
                }
            })
        },
    },
    created(){
        this.getData();
    },
    activated() {
        this.getData()
    },
}
</script>

<style lang="less" scoped>

</style>
